module.exports = __webpack_public_path__ + "img/profile-icon.2a26db8c.svg";